export default "__VITE_ASSET__CO_UhlCF__"